import { IPrintPdfSource } from "../../../domain/drawing/IPrintPdfSource";

export class PrintPdfSource implements IPrintPdfSource {
  source: string;

  constructor(public blob: Blob) {
    this.source = URL.createObjectURL(blob);
  }

  public clone(): IPrintPdfSource {
    return new PrintPdfSource(
      this.blob
    );
  }
}
